export enum EmploymentStatus {
  'EMPLOYED_FULL_TIME' = 'employedFullTime',
  'EMPLOYED_PART_TIME' = 'employedPartTime',
  'EMPLOYED_CASUAL' = 'employedCasual',
  'SELF_EMPLOYED' = 'selfEmployed',
  'STUDENT' = 'student',
  'RETIRED' = 'retired',
  'NOT_EMPLOYED' = 'notEmployed',
}
